/* eslint-disable click-events-have-key-events, no-static-element-interactions */
import React from 'react';
import { IconChevronDownCircleOutline } from '@zillow/constellation';
import * as S from './styles';

const MoreButton = (props = {}) => {
    const handleClick = () => {
        window.scroll({
            top: props.scrollTop || 782,
            left: 0,
            behavior: 'smooth',
        });
    };

    return (
        <S.PlacementWrapper>
            <div onClick={handleClick}>
                <IconChevronDownCircleOutline fontColor="textWhite" size="md" />
            </div>
            <S.Text>
                MORE
            </S.Text>
        </S.PlacementWrapper>
    );
};

export default MoreButton;
